import React, { memo } from "react";
import PropTypes from "prop-types";
import ProgressPercentage from "./progress-percentage";
import Spinner from "../spinner/spinner";
import "./loading-overlay.scss";

type LoadingOverlayProps = {
    show?: boolean;
    message?: string;
    showPercentage?: boolean;
    title?: string;
};

const LoadingOverlay: React.FC<LoadingOverlayProps> = (
    props: LoadingOverlayProps
) => {
    const { show, message, showPercentage, title } = props;
    return (
        <>
            {show && (
                <div data-testid="LoadingOverlay" className="loading-overlay">
                    <div className="loading-overlay__container">
                        <Spinner stroke={3} />
                        {showPercentage && (
                            <span className="loading-overlay__percentage">
                                <ProgressPercentage />%
                            </span>
                        )}
                    </div>
                    {title && <h5>{title}</h5>}
                    <h6>{message}</h6>
                </div>
            )}
        </>
    );
};

LoadingOverlay.propTypes = {
    show: PropTypes.bool,
    message: PropTypes.string,
    showPercentage: PropTypes.bool,
    title: PropTypes.string,
};

LoadingOverlay.defaultProps = {
    show: false,
    showPercentage: true,
    message: "Cargando...",
    title: null,
};

export default memo(LoadingOverlay);
